<template>
    <div>
        <div class="pb-2">
            <label class="ds-login-input-label">
                <slot></slot>
            </label>
        </div>
        <div class="relative">
            <input ref="inputRef" :type="inputType" :value="modelValue" :autocomplete="autocomplete" class="ds-login-input-field max-w-lg" :maxlength="maxLength"
                @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)">
            <icon v-if="type == 'password'" class="absolute top-5 right-5 cursor-pointer" @click="switchType">
                <icon-eye-x />
            </icon>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import IconEyeX from './icons/IconEyeX.vue'

const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    modelValue: {
        type: String,
        default: ''
    },
    maxLength: {
        type: String,
        required: false
    },
    autocomplete: {
        type: String,
        required: false
    }
})
defineEmits(['update:modelValue'])

const inputType = ref(props.type)
const inputRef = ref<HTMLInputElement | null>(null)

function switchType() {
    inputType.value = (inputType.value === 'string') ? 'password' : 'string'
}

function getValue() {
    return inputRef.value?.value ?? ''
}

defineExpose({
    getValue
})

</script>

<style scoped>
input {
    &:focus {
        outline-color: #d2d2d2;
    }
}
</style>
